import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { useHistory } from "react-router-dom";
import { Modal, ChangePassword } from '../../../imports';
import {
    Bars3Icon, XMarkIcon, ChevronLeftIcon, ChevronRightIcon, DocumentTextIcon, ChartBarIcon,
    WrenchScrewdriverIcon, ClipboardDocumentListIcon, ArrowRightOnRectangleIcon, UserCircleIcon, ExclamationTriangleIcon
} from "@heroicons/react/24/outline";
import Logo from '../../../assets/logo.png';
import { ObtenerUsuarioPorId } from '../../../servicios/ServicioUsuario';

const Sidebar = ({ email }) => {
    const [showModal, setShowModal] = useState(false);
    const [isSubMenuHidden, setIsSubMenuHidden] = useState(true);
    const [isSubMenuReportsHidden, setIsSubMenuReportsHidden] = useState(true);
    const [isSidebarHidden, setIsSidebarHidden] = useState(false);
    const [isControlShow, setIsControlShow] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
        setIsSubMenuReportsHidden(true);
        setIsSubMenuHidden(true);
    };

    const [showModalEdit, setShowModalEdit] = useState(false);
    const [fieldsData, setFieldsData] = useState([]);
    const [idUsuario, setIdUsuario] = useState(0);
    const history = useHistory();

    const { handleSubmit } = useForm({ mode: 'all' });

    const onClosesession = () => {
        sessionStorage.clear();
        window.location.replace('/login');
    };

    async function getUserById() {
        const jsonUsuario = sessionStorage.getItem("USER_DATA");
        const usuario = JSON.parse(jsonUsuario);
        const response = await ObtenerUsuarioPorId(usuario.IdUsuario);
        setFieldsData(response);
        setIdUsuario(usuario.IdUsuario);
    }

    useEffect(() => {
        getUserById();
        setShowModal(false);
    }, []);

    const toggleSubMenu = () => {
        setIsCollapsed(false);
        setIsSubMenuHidden(!isSubMenuHidden);
    };

    const toggleSubMenuReports = () => {
        setIsCollapsed(false);
        setIsSubMenuReportsHidden(!isSubMenuReportsHidden);
    };

    const toggleSidebar = () => {
        setIsSidebarHidden(!isSidebarHidden);
    };

    const SingoutComponent = () => (
        <form className="space-y-2 md:space-y-4">
            <div className="w-96 container mx-auto items-center justify-center">
                <div className="flex flex-col">
                    <div className="flex text-base m-2 justify-center mx-auto font-bold leading-tight tracking-tight text-red-RS">
                        <ExclamationTriangleIcon className="w-8 h-8 ml-2" />
                    </div>
                    <div>
                        <h1 className="flex text-base justify-center mx-auto font-bold leading-tight tracking-tight text-white">
                            Advertencia
                        </h1>
                    </div>
                    <div>
                        <label className="flex text-base justify-center mx-auto m-2 py-2 text-sm font-medium text-white">
                            ¿Está seguro que desea cerrar sesión?
                        </label>
                    </div>
                </div>
            </div>
        </form>
    );

    useEffect(() => {
        if (window.innerWidth < 900) setIsControlShow(true);

        const handleResize = () => {
            if (window.innerWidth >= 640) {
                setIsSidebarHidden(false);
                setIsControlShow(false);
            } else {
                setIsControlShow(true);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [showModal]);

    return (
        <>
            <span
                className={`text-white text-4xl top-5 left-4 cursor-pointer ${isSidebarHidden ? "absolute" : "hidden"}`}
                onClick={toggleSidebar}
            >
                <Bars3Icon className="h-8 w-8" />
            </span>

            <div
                className={`h-screen fixed z-40 top-0 left-0 bg-black-RS text-white transform ${isSidebarHidden ? "-translate-x-full" : "translate-x-0"
                    } transition-transform duration-300 ease-in ${isCollapsed ? "w-20" : "w-70"}`}
            >
                <div className="h-full overflow-y-auto px-4 py-6 flex flex-col">

                    <button
                        className="mb-4 p-2 text-white hover:bg-gray-700 rounded-md self-end"
                        onClick={toggleCollapse}
                    >
                        {isCollapsed ? <ChevronRightIcon className="h-6 w-6" /> : <ChevronLeftIcon className="h-6 w-6" />}
                    </button>

                    <figure className={`flex justify-center mx-auto mb-6 ${isCollapsed ? "hidden" : "block"}`}>
                        <img src={Logo} alt="Logo RS" style={{ objectFit: "contain" }} className="w-40 h-28" />
                    </figure>

                    <nav className="flex-1">
                        <Link to="/curriculums" className="flex items-center p-3 mb-2 rounded-md hover:bg-grayLight-RS transition-all">
                            <DocumentTextIcon className="h-8 w-8" />
                            {!isCollapsed && <span className="ml-2 text-[15px] font-bold">Currículums</span>}
                        </Link>

                        <Link to="/procesos" className="flex items-center p-3 mb-2 rounded-md hover:bg-grayLight-RS transition-all">
                            <ChartBarIcon className="h-8 w-8" />
                            {!isCollapsed && <span className="ml-2 text-[15px] font-bold">Procesos internos</span>}
                        </Link>

                        {/* SUBMENÚ PARÁMETROS */}
                        <div>
                            <div
                                className="flex items-center p-3 mb-2 rounded-md cursor-pointer hover:bg-grayLight-RS transition-all"
                                onClick={toggleSubMenu}
                            >
                                <WrenchScrewdriverIcon className="h-8 w-8" />
                                {!isCollapsed && (
                                    <div className="flex justify-between w-full items-center">
                                        <span className="text-[15px] font-bold">Parámetros</span>
                                        <ChevronLeftIcon className={`h-6 w-6 transform transition-transform ${isSubMenuHidden ? "" : "rotate-180"}`} />
                                    </div>
                                )}
                            </div>

                            <div className={`ml-8 transition-all duration-300 ${isSubMenuHidden ? "hidden" : "block"}`}>
                                <Link to="/role_catalog" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Roles</Link>
                                <Link to="/usuario_catalog" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Usuarios</Link>
                                <Link to="/tecnologia_catalog" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Tecnologías</Link>
                                <Link to="/grade_catalog" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Grados Académicos</Link>
                                <Link to="/catalogos" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Vacantes</Link>
                                <Link to="/proyectos" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Proyectos</Link>

                                <Link to="/formulario_catalog" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">
                                    Formularios
                                </Link>

                                {/* 🔹 NUEVA OPCIÓN */}
                                <Link to="/evaluacion_catalog" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">
                                    Evaluaciones
                                </Link>

                                <Link to="/especialidad_catalog" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Especialidades</Link>
                                <Link to="/tipoedu_catalog" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-white">Tipo Educación</Link>
                                <Link to="/contacto_catalog" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Contactos</Link>
                            </div>
                        </div>

                        {/* SUBMENÚ REPORTES */}
                        <div>
                            <div
                                className="flex items-center p-3 mb-2 rounded-md cursor-pointer hover:bg-grayLight-RS transition-all"
                                onClick={toggleSubMenuReports}
                            >
                                <ClipboardDocumentListIcon className="h-8 w-8" />
                                {!isCollapsed && (
                                    <div className="flex justify-between w-full items-center">
                                        <span className="text-[15px] font-bold">Reportes</span>
                                        <ChevronLeftIcon className={`h-6 w-6 transform transition-transform ${isSubMenuReportsHidden ? "" : "rotate-180"}`} />
                                    </div>
                                )}
                            </div>
                            <div className={`ml-8 transition-all duration-300 ${isSubMenuReportsHidden ? "hidden" : "block"}`}>
                                <Link to="/reporte_gradoacademico" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS">Personas por Grado</Link>
                                <Link to="/reporte_personas" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Personas Trabajando en Rossmon</Link>
                                <Link to="/reporte_tecnologias" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Profesionales por Tecnología</Link>
                                <Link to="/reporte_profesionalesespecialidad" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS">Profesionales por especialidad</Link>
                                <Link to="/reporte_evaluaciones" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS"> Evaluaciones por Persona/Formulario</Link>
                                <Link to="/evaluaciones_personas" className="block p-2 mb-1 rounded-md hover:bg-grayLight-RS hover:text-black-RS"> Reporte de Evaluacion por formulario</Link>   
                                
                            </div>
                        </div>
                    </nav>

                    <button onClick={() => setShowModal(true)} className="flex items-center w-full p-3 rounded-md hover:bg-grayLight-RS transition-all">
                        <ArrowRightOnRectangleIcon className="h-8 w-8" />
                        {!isCollapsed && <span className="ml-2 text-[15px] font-bold">Cerrar sesión</span>}
                    </button>

                    <button onClick={() => setShowModalEdit(true)} className="flex items-center w-full p-3 rounded-md hover:bg-grayLight-RS transition-all">
                        <UserCircleIcon className="h-8 w-8" />
                        {!isCollapsed && <span className="ml-2 text-[15px] font-bold">{email}</span>}
                    </button>
                </div>
            </div>

            <Modal
                isVisible={showModal}
                onClose={() => setShowModal(false)}
                handleSubmit={handleSubmit}
                onSaveOptions={onClosesession}
            >
                <SingoutComponent />
            </Modal>

            <Modal
                isVisible={showModalEdit}
                onClose={() => setShowModalEdit(false)}
                handleSubmit={() => null}
                onSaveOptions={null}
                showFotter={false}
                showCloseIcon={true}
            >
                <ChangePassword
                    setShowModalEdit={setShowModalEdit}
                    fieldsData={fieldsData}
                    idUsuario={idUsuario}
                    getUserById={getUserById}
                />
            </Modal>

            <span
                className={`text-white absolute top-5 right-4 cursor-pointer ${isSidebarHidden ? "block" : "hidden"}`}
                onClick={toggleSidebar}
            >
                <XMarkIcon className="h-8 w-8" />
            </span>
        </>
    );
};

export default Sidebar;
